import { ZfFormField, ZfIcon, ZfPopover, ZfSlider, ZfStack, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useGeneralSimulationSettings } from '../../../hooks/useGeneralSimulationSettings';
import { roundTo2Decimals } from '../../../utils/utils';

const minCustomReturn = 0;
const maxCustomReturn = 10;

interface IMonteCarloGeneralCustomSettingsProps {
    padding?: string;
}

export const MonteCarloGeneralCustomSettings: FunctionComponent<IMonteCarloGeneralCustomSettingsProps> = ({ padding }) => {
    const { t } = useTranslation();
    const { settings, patchSettings } = useGeneralSimulationSettings();

    const handleCustomReturnChange = (event: CustomEvent<number>) => patchSettings({ customReturn: event.detail / 100 });

    return (
        <ZfStack direction="column" spacing="small" style={{ color: 'var(--fg-color-default-normal)', padding }}>
            <ZfFormField label={t('customReturn')}>
                <ZfSlider
                    value={roundTo2Decimals((settings?.customReturn ?? 0) * 100)}
                    valueLabel="%"
                    min={minCustomReturn}
                    max={maxCustomReturn}
                    step={0.5}
                    marks
                    onValueChangeCommitted={handleCustomReturnChange}
                    scalePosition="bottom"
                >
                    <ZfTypography slot="start" variant="label-tiny" color="normal">
                        {minCustomReturn}%
                    </ZfTypography>
                    <ZfTypography slot="end" variant="label-tiny" color="normal">
                        {maxCustomReturn}%
                    </ZfTypography>
                </ZfSlider>
                <ZfPopover slot="label-trailing" alignment="start">
                    <ZfIcon slot="anchor" size="medium" name="info" style={{ cursor: 'pointer' }} />
                    <ZfTypography variant="label-extra-small" color="normal">
                        {t('customReturnInfoBox')}
                    </ZfTypography>
                </ZfPopover>
            </ZfFormField>
        </ZfStack>
    );
};
